import { ArrowLeftIcon } from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";

function UpdateStreamingDevice() {
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  const [uuid] = useState(argumentData?.id || "");
  const [isLoading, setIsLoading] = useState(false);
  const [deviceName, setDeviceName] = useState(argumentData?.device_name || "");
  const [ipAddress, setIpAddress] = useState(argumentData?.ip_address || "");
  const [urlRtsp, setUrlRtsp] = useState(argumentData?.device_url_rtsp || "");
  const [latitudeDevice, setLatitudeDevice] = useState(
    argumentData?.latitude_device || ""
  );
  const [longitudeDevice, setLongitudeDevice] = useState(
    argumentData?.longitude_device || ""
  );
  const [organizationId, setOrganizationId] = useState(
    argumentData?.device_organization_id || ""
  );
  const [deviceTypeID, setDeviceTypeID] = useState(
    argumentData?.device_type_id || ""
  );
  const [operationId, setOperationID] = useState(
    argumentData?.operation_id || ""
  );
  const [dataOrganization, setDataOrganization] = useState([]);
  const [dataDeviceType, setDataDeviceType] = useState([]);
  const [dataOperation, setDataOperation] = useState([]);

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.streaming_device.streaming_device_home);
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getDataOrganization = async () => {
    try {
      setIsLoading(true);
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const response = await fetchApi().get(
        `/organization/get-list?${paramPage}&${paramSize}`
      );
      setDataOrganization(response.data.data);
      getDataDeviceType();
    } catch (err) {
      setDataOrganization([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const getDataDeviceType = async () => {
    try {
      const response = await fetchApi().get(`/device-type/get-list`);
      const filterFlagData = response.data?.data.filter(
        (item) => item.flag_active_device_type === true
      );
      setDataDeviceType(filterFlagData);
      getDataOperation();
    } catch (err) {
      setDataOrganization([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const getDataOperation = async () => {
    try {
      const paramPage = `page=0`;
      const paramSize = `size=999`;
      const paramOrganization =
        yuridiksi_user_code !== "N"
          ? `organizationId=${organisasi_user_id}`
          : `organizationId=`;
      const response = await fetchApi().get(
        `/operation/get-list?${paramPage}&${paramSize}&${paramOrganization}`
      );
      setDataOperation(response.data.data);
      setIsLoading(false);
    } catch (err) {
      setDataOperation([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  const updateData = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        device_name: deviceName,
        ip_address: ipAddress,
        device_url_rtsp: urlRtsp,
        latitude_device: latitudeDevice,
        longitude_device: longitudeDevice,
        device_organization_id: organizationId,
        device_type_id: deviceTypeID,
        operation_id: operationId,
      };
      const response = await fetchApi().put(
        `/streaming-device/update/${uuid}`,
        reqBody
      );
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    updateData();
  };

  useEffect(() => {
    getDataOrganization();
  }, []);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Tambah Data Perangkat Streaming
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="device_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Perangkat
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="device_name"
                  name="device_name"
                  type="text"
                  disabled={isLoading}
                  value={deviceName}
                  placeholder="Masukkan Nama Perangkat"
                  onChange={(e) => setDeviceName(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="mb-2 w-2/4">
              <label
                htmlFor="device_type"
                className="flex block text-sm font-medium leading-6"
              >
                Jenis Perangkat
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="device_type"
                    name="device_type"
                    required
                    value={deviceTypeID}
                    onChange={(e) => setDeviceTypeID(e.target.value)}
                    className={`h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Jenis Perangkat
                    </option>
                    {dataDeviceType.map((item) => (
                      <option value={item.id}>{item.device_type_name}</option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="ip_address"
                className="flex block text-sm font-medium leading-6"
              >
                IP Address
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="ip_address"
                  name="ip_address"
                  type="text"
                  disabled={isLoading}
                  value={ipAddress}
                  placeholder="Masukkan IP Address"
                  onChange={(e) => setIpAddress(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="url_rtsp"
                className="flex block text-sm font-medium leading-6"
              >
                URL RTSP
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="url_rtsp"
                  name="url_rtsp"
                  type="text"
                  disabled={isLoading}
                  value={urlRtsp}
                  placeholder="Masukkan URL RTSP"
                  onChange={(e) => setUrlRtsp(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="latitude_device"
                className="block text-sm font-medium leading-6"
              >
                Latitude Lokasi
              </label>
              <div className="mt-2">
                <input
                  id="latitude_device"
                  name="latitude_device"
                  type="text"
                  disabled={isLoading}
                  value={latitudeDevice}
                  placeholder="Masukkan Latitude Lokasi"
                  onChange={(e) => setLatitudeDevice(e.target.value)}
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="longitude_device"
                className="block text-sm font-medium leading-6"
              >
                Longitude Lokasi
              </label>
              <div className="mt-2">
                <input
                  id="longitude_device"
                  name="longitude_device"
                  type="text"
                  disabled={isLoading}
                  value={longitudeDevice}
                  placeholder="Masukkan Longitude Lokasi"
                  onChange={(e) => setLongitudeDevice(e.target.value)}
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 w-2/4 mr-5">
              <label
                htmlFor="operation_organization_id"
                className="flex block text-sm font-medium leading-6"
              >
                Organisasi Penanggung Jawab Perangkat
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="operation_organization_id"
                    name="operation_organization_id"
                    required
                    value={organizationId}
                    disabled={yuridiksi_user_code !== "N" ? true : false}
                    onChange={(e) => setOrganizationId(e.target.value)}
                    className={`${
                      yuridiksi_user_code !== "N" ? "bg-zinc-100" : ""
                    } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Organisasi
                    </option>
                    {dataOrganization.map((item) => (
                      <option value={item.id}>{item.organization_name}</option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 w-2/4">
              <label
                htmlFor="operation_police"
                className="flex block text-sm font-medium leading-6"
              >
                Operasi Kepolisian
                {permission_flag?.streaming?.addData !== undefined &&
                permission_flag?.streaming?.addData === true ? (
                  <u>
                    <Link
                      to={
                        ROUTES.management_data.OperationPolice
                          .operation_police_home
                      }
                      target="_blank"
                      className="ml-3 text-blue-500 hover:text-blue-900"
                    >
                      Tambah Data Operasi Baru
                    </Link>
                  </u>
                ) : null}
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="operation_police"
                    name="operation_police"
                    value={operationId}
                    onChange={(e) => setOperationID(e.target.value)}
                    className={`h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled selected hidden>
                      Pilih Operasi Kepolisian
                    </option>
                    {dataOperation.map((item) => (
                      <option value={item.id}>{item.operation_name}</option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdateStreamingDevice;
